type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  actionText?: string;
  actionHref?: string;
  actionIcon?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionText,
  actionHref = "#top",
  actionIcon = "ri-arrow-right-line",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 border-b border-background-200 pb-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="min-w-0">
        <div className="mb-2 flex items-center gap-2">
          <span className="h-3.5 w-1 rounded-full bg-primary-500" />
          <span className="font-label text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionText && (
        <a
          href={actionHref}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          {actionText}
          <i className={`${actionIcon} text-base`} />
        </a>
      )}
    </div>
  );
}